export default () => {
  const openIntercom = (message = '') => {
    // Only run on client-side
    if (import.meta.client && typeof window !== 'undefined' && (window as any).Intercom) {
      (window as any).Intercom('showNewMessage', message);
    }
  };
  return {
    openIntercom,
  };
};
